import { ContentPasteOutlined, CopyAllOutlined, EditOutlined } from "@mui/icons-material";
import { styled, SxProps, Box, Button } from "@mui/material";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { useTranslation } from "react-i18next";

export type CodeBoxProps = {
  sx?: SxProps;
  className?: string;
  text: any;
  xml?: boolean;
  copyEnable?: boolean;
  onClickPaste?: (e: any) => void;
  onClickEdit?: (e: any) => void;
};

const CodeBox: React.FC<CodeBoxProps> = (props) => {
  const { text, xml, copyEnable = false, onClickEdit, onClickPaste } = props;
  const { t } = useTranslation();
  const enqueuCustomSnackbar = useCustomSnackbar();
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(xml === undefined || xml === false ? JSON.stringify(text, null, 2) : text);
    enqueuCustomSnackbar(t("alert:success.copiedToClipboard"), "success");
  };
  return (
    <StyledBox>
      {copyEnable && (
        <Box display={"flex"} flexDirection={"row"} position={"absolute"} sx={{ top: "12px", right: "12px" }}>
          {onClickEdit && (
            <Button color="primary" variant="outlined" onClick={onClickEdit} sx={{ mr: 1 }}>
              <EditOutlined />
            </Button>
          )}

          {copyEnable && (
            <Button onClick={handleCopyToClipboard} color="info" startIcon={<CopyAllOutlined />} sx={{ mr: 1 }}>
              {t("button:copyToClipboard")}
            </Button>
          )}
          {onClickPaste && (
            <Button color="primary" variant="outlined" onClick={onClickPaste} startIcon={<ContentPasteOutlined />}>
              {t("button:pasteClipboard")}
            </Button>
          )}
        </Box>
      )}
      <StyledPre>{xml === undefined || xml === false ? JSON.stringify(text, null, 2) : text}</StyledPre>
    </StyledBox>
  );
};

export default CodeBox;

const StyledBox = styled(Box)(({ theme }) => ({
  border: "1px solid grey",
  overflowWrap: "anywhere",
  wordBreak: "break-all",
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.secondary,
  borderRadius: "5px",
  fontSize: "11px",
  position: "relative",
}));

const StyledPre = styled("pre")(({ theme }) => ({
  overflowWrap: "anywhere",
  wordBreak: "break-all",
  whiteSpace: "pre-wrap",
  padding: 5,
  margin: 0,
}));
